import { RankingControlTable } from "./RankingControlTable";

export default RankingControlTable;
